<template>
  <el-table
    ref="commonTable"
    :empty-text="empty"
    :data="tableData"
    @selection-change="handleSelectionChange"
    style="width: 100%"
    :cell-style="{'whiteSpace':'nowrap','textOverflow': 'ellipsis'}"
  >
    <el-table-column
      type="selection"
      :selectable="isCanSelect"
      v-if="isShowSection"
    />
    <el-table-column
      v-for="(item,index) in thead"
      :key="index"
      :prop="tpropty[index]"
      :label="item.label||item"
      :align="item.align||'center'"
      :min-width="item.width||0"
    >
      <template slot-scope="scope">
        <!-- <span
          class="btnOperate"
          v-if="tpropty[index]==='btnOperate'"
        >
          <a
            @click="handleCommand(scope.row,'alter')"
            :class="{'disabled': !scope.row['btnOperate']}"
            :title="scope.row['btnOperate']?'':'权限不足'"
          >修改</a>
          <a
            @click="handleCommand(scope.row,'del')"
            :class="{'disabled': !scope.row['btnOperate']}"
            :title="scope.row['btnOperate']?'':'权限不足'"
          >删除</a>
        </span> -->
        <span
          :title="scope.row[tpropty[index]] "
        >{{ scope.row[tpropty[index]] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    thead: {
      type: Array,
      default: () => []
    },
    tpropty: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    empty: {
      type: String,
      default: () => '暂无数据'
    },
    isShowSection: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      ids: []
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id)
      this.$emit('handleSelectionChange', this.ids)
    },
    handleCommand(value, flag) {
      if (!value.btnOperate) return false
      this.$emit('handleCommand', { value: value, flag: flag })
    },
    isCanSelect(row, index) {
      if (setting_role_open) {
        return 1
      } else {
        if (row.btnOperate) {
          return 1
        } else {
          return 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table {
  /deep/ .cell {
    font-weight: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: text;
  }
  /deep/ .el-table__empty-text {
    font-size: 14px;
    color: #999999;
  }
  /deep/ thead {
    color: #454647;
    font-size: 14px;
    th {
      height: 51px;
      border: none;
      background-color: #fff;
    }
  }
  /deep/ .el-table__body-wrapper {
    height: calc(100vh - 270px);
    overflow-y: auto;
  }
  /deep/ tbody {
    font-size: 14px;
    color: #666666;
    tr {
      td {
        border: none;
        background-color: #fff;
      }
      &:nth-child(2n) {
        td {
          background-color: #f4f5fc;
        }
      }
    }
    td {
      height: 48px;
      font-size: 13px;
      .btnOperate {
        a {
          margin-right: 14px;
          color: #4397eb;
          text-decoration: underline;
          cursor: pointer;
          &.disabled{
            cursor: auto;
            color:#999;
          }
          &:last-child{
            margin:0;
          }
        }
      }
      .el-checkbox__input.is-disabled .el-checkbox__inner{
        border-color: #c1c1c1;
      }
    }
  }
}
</style>
